import React from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import FormError from "../../../components/forms/FormError";
import TextInputField from "../../../components/forms/TextInputField";

const ScanBarcodeForm = (props) => {
  let {errors, handleSubmit, submit, submitting} = props;
  let submitLabel = submitting ? "Submiting Barcode..." : "Submit Barcode";
  // TODO: submitting: replace whole form with "Validating Barcode with Serial Number" and loader

  return (
    <form onSubmit={handleSubmit}>
      <div className="fields">
        <Field
          label="Barcode"
          name="barcode"
          table={false}
          component={TextInputField}
          serverError={props.errors.barcode}
          />
      </div>
      <FormError error={errors._error} />
      <div className="buttons">
        <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
      </div>
    </form>
  );
}

const ReduxForm = reduxForm({
  form: "ScanBarcodeForm"
})(ScanBarcodeForm);

export default ReduxForm;